
import { Editor, createDomElement } from "slickgrid-react";
import { useState } from 'react';
import $ from 'jquery'


function getBase64aa(file:Blob) {
  var reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = function () {
    //console.log(reader.result);

  };
  reader.onerror = function (error) {
    console.log('Error: ', error);
  };
}

  async function getBase64(file: Blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      resolve(reader.result)
    }
    reader.onerror = reject
  })
  
 
  
}



export class FileEditor implements Editor{
    
    $input: any  ;
    scope = this;
    args: any;
    filename=""
    b64=""
    constructor( args:any, inputType:any) {
        this.args = args;

        this.init();

    }

    

   
    
    init() {
        this.$input  = createDomElement('input');
        this.$input.accept=".xls"
        this.$input.type="file"
        this.$input.id = 'importfile'
        this.$input.onchange= '{readURL(this.value)}'
      
        const cellContainer = this.args.container;

        cellContainer.appendChild(this.$input);

        
    }
    destroy() {}
    focus() {
      
    }
    loadValue(e:any) {
      
       //this.imageChange(this.$input)
    }
    async serializeValue() {
      //console.log(this.filename)
      //console.log($(this.$input))

      if ($(this.$input)[0].files && ($(this.$input)[0].files.length>0)){
       var tmp = String(await getBase64($(this.$input)[0].files[0]))
       return {name: $(this.$input)[0].files[0].name, data:tmp} // $(this.$input)[0].files[0].name

      }else{
        return {name:'', data:''}
      }
      
    }
    applyValue(item:any, state:any) {
        item.file = state
      //item.color =state
    }
    isValueChanged()  {
        return true
    }
    validate(targetElm:any, options:any)  {
        return {valid:true}
    }
    show() {
      /*
       *
       * We setup a brief timeout that gives the browser enough time to finish
       * preparing the specturm widget. If we don't wait for 100 milliseconds,
       * opening the color picker will take two clicks. This is also a
       * consequence of spectrum initializing asynchronously, by the time
       * SlickGrid executes the show method the widget is not ready yet so the
       * 'spectrum('show')' call results in a noop, and in order to show the
       * color picker users would need to click again on the colorbox.
       *
       */
      
      //this.init();
  }
  }

